/**
 * Convert data from coachee API to internal format
 * @param {Object} coachee Coachee API data
 * @param {Number} coachee.job_title Position
 * @param {String} coachee.job_title_display Position verbose name
 * @param {String} coachee.mobile Mobile phone number
 * @param {String} coachee.school_type School type
 * @param {Number} coachee.school_type_display School type verbose name
 * @param {String} coachee.telephone Phone number
 * @returns {Object} Converted coachee data
 */
export default function (coachee) {
  return {
    phone: coachee.telephone,
    phoneMobile: coachee.mobile,
    position: coachee.job_title,
    positionDisplay: coachee.job_title_display,
    school: coachee.school,
    schoolType: coachee.school_type,
    schoolTypeDisplay: coachee.school_type_display
  }
}
